/*
 * Critter fur color catalog. Ported verbatim from v0.2.
 *
 * Each entry is one "fur" — a body color and a complementary belly color.
 * Indices are persistent; reordering changes existing saves.
 */

export interface FurColor {
  /** Display name. */
  name: string;
  /** Body color (CSS hex). */
  body: string;
  /** Lighter belly + ear-inner color (CSS hex). */
  belly: string;
}

export const FUR_COLORS: readonly FurColor[] = [
  { name: 'fox',   body: '#c97c4a', belly: '#f5e0c0' },
  { name: 'mouse', body: '#9b9b9b', belly: '#e8e0d0' },
  { name: 'cream', body: '#e8d4a8', belly: '#fff4dc' },
  { name: 'plum',  body: '#7a5a8a', belly: '#d8c8e0' },
  { name: 'moss',  body: '#6b8a5a', belly: '#d4dcc0' },
] as const;

/** Safe lookup that falls back to fox if the index is out of range. */
export function furAt(index: number): FurColor {
  return FUR_COLORS[index] ?? FUR_COLORS[0]!;
}
